<template>
  <advertising>
    <div class="d-flex flex-lg-wrap flex-nowrap">
      <div class="col-md-3 col-sm-4 col-6 col-lg-12 mb-lg-2 me-lg-0 me-2">
        <div id="adfox_168504688565147459" class="w-100"></div>
      </div>
      <div class="col-md-3 col-sm-4 col-6 col-lg-12 mb-lg-2 mx-lg-0 mx-2">
        <div id="adfox_168512591370465839" class="w-100"></div>
      </div>
      <div class="col-md-3 col-sm-4 col-6 col-lg-12 mb-lg-2 mx-lg-0 mx-2">
        <div id="adfox_168512274007539685" class="w-100"></div>
      </div>
      <div class="col-md-3 col-sm-4 col-6 col-lg-12 mb-max ms-lg-0 ms-2">
        <div id="adfox_168512278807292621" class="w-100"></div>
      </div>
    </div>
  </advertising>
</template>

<script>
import Advertising from "@/components/advertising/Advertising";
import {onMounted} from "vue";

export default {
  name: "advertising-left",
  components: {Advertising},
  setup() {
    onMounted(() => {
      window.yaContextCb.push(() => {
        // noinspection JSUnresolvedVariable,JSUnresolvedFunction,SpellCheckingInspection
        Ya.adfoxCode.createAdaptive({
          ownerId: 715164,
          containerId: 'adfox_168504688565147459',
          params: {
            p1: 'cygsw',
            p2: 'p'
          }
        }, ['desktop', 'tablet', 'phone'], {
          tabletWidth: 830,
          phoneWidth: 480,
          isAutoReloads: true
        })
      })
      window.yaContextCb.push(() => {
        // noinspection JSUnresolvedVariable,JSUnresolvedFunction,SpellCheckingInspection
        Ya.adfoxCode.createAdaptive({
          ownerId: 715164,
          containerId: 'adfox_168512591370465839',
          params: {
            p1: 'cygzp',
            p2: 'p'
          }
        }, ['desktop', 'tablet', 'phone'], {
          tabletWidth: 830,
          phoneWidth: 480,
          isAutoReloads: true
        })
      })
      window.yaContextCb.push(() => {
        // noinspection JSUnresolvedVariable,JSUnresolvedFunction,SpellCheckingInspection
        Ya.adfoxCode.createAdaptive({
          ownerId: 715164,
          containerId: 'adfox_168512274007539685',
          params: {
            p1: 'cygzs',
            p2: 'p'
          }
        }, ['desktop', 'tablet', 'phone'], {
          tabletWidth: 830,
          phoneWidth: 480,
          isAutoReloads: true
        })
      })
      window.yaContextCb.push(() => {
        // noinspection JSUnresolvedVariable,JSUnresolvedFunction,SpellCheckingInspection
        Ya.adfoxCode.createAdaptive({
          ownerId: 715164,
          containerId: 'adfox_168512278807292621',
          params: {
            p1: 'cygzu',
            p2: 'p'
          }
        }, ['desktop', 'tablet', 'phone'], {
          tabletWidth: 830,
          phoneWidth: 480,
          isAutoReloads: true
        })
      })
    })
  }
}
</script>

<style scoped>
@media (min-width: 992px) {
  .mb-max {
    margin-bottom: 4.5rem !important;
  }
}

</style>